/**
 * useHospitalModals - Hook for managing hospital page modal states
 *
 * Manages:
 * - Local modal
 * - Representante modal
 * - Import modals (hospitais, locais, representantes)
 * - Dropdown visibility
 */
import { useState } from 'react';

export function useHospitalModals() {
  // Modal states
  const [showLocalModal, setShowLocalModal] = useState(false);
  const [showRepresentanteModal, setShowRepresentanteModal] = useState(false);
  const [showImportRepresentantesModal, setShowImportRepresentantesModal] = useState(false);
  const [showImportHospitaisModal, setShowImportHospitaisModal] = useState(false);
  const [showImportLocaisModal, setShowImportLocaisModal] = useState(false);
  const [showBulkImportLocaisModal, setShowBulkImportLocaisModal] = useState(false);

  // Dropdown state
  const [showHospitalDropdown, setShowHospitalDropdown] = useState(false);

  // Helper functions
  const openImportHospitaisModal = () => {
    setShowImportHospitaisModal(true);
  };

  const closeImportHospitaisModal = () => {
    setShowImportHospitaisModal(false);
  };

  const openImportLocaisModal = () => {
    setShowImportLocaisModal(true);
  };

  const closeImportLocaisModal = () => {
    setShowImportLocaisModal(false);
  };

  const openBulkImportLocaisModal = () => {
    setShowBulkImportLocaisModal(true);
  };

  const closeBulkImportLocaisModal = () => {
    setShowBulkImportLocaisModal(false);
  };

  const openLocalModal = () => {
    setShowLocalModal(true);
  };

  const closeLocalModal = () => {
    setShowLocalModal(false);
  };

  const toggleHospitalDropdown = () => {
    setShowHospitalDropdown(prev => !prev);
  };

  const closeHospitalDropdown = () => {
    setShowHospitalDropdown(false);
  };

  return {
    // Modal states
    showLocalModal,
    setShowLocalModal,
    showRepresentanteModal,
    setShowRepresentanteModal,
    showImportRepresentantesModal,
    setShowImportRepresentantesModal,
    showImportHospitaisModal,
    setShowImportHospitaisModal,
    showImportLocaisModal,
    setShowImportLocaisModal,
    showBulkImportLocaisModal,
    setShowBulkImportLocaisModal,

    // Dropdown
    showHospitalDropdown,
    setShowHospitalDropdown,

    // Helper functions
    openImportHospitaisModal,
    closeImportHospitaisModal,
    openImportLocaisModal,
    closeImportLocaisModal,
    openBulkImportLocaisModal,
    closeBulkImportLocaisModal,
    openLocalModal,
    closeLocalModal,
    toggleHospitalDropdown,
    closeHospitalDropdown,
  };
}
